export default function Header() {
    return (
        <div className="flex w-full flex-col items-start border-b border-dark-blue px-4 py-3">
            <div className="flex items-center justify-between">
                <h1 className="text-base font-normal leading-5 text-white">Filters</h1>
            </div>
        </div>
    );
}
